import { h } from '@debbie/cortex/dist/index.js';
import { useMe } from '@debbie/cortex/dist/me/index.js';
import React from 'react';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import Panel from '../Panel.js';
import SelectableEntities from './SelectableEntities.js';
const AccountSelectorPage = () => {
    const meLoader = useMe();
    const me = h.hasData(meLoader) ? meLoader.data : null;
    return (React.createElement(StyledPage, null,
        React.createElement(SelectorWrapper, null,
            React.createElement(Panel, null, me ? React.createElement(SelectableEntities, { tenants: me.tenants }) : React.createElement(React.Fragment, null)))));
};
export default AccountSelectorPage;
const StyledPage = styled.div `
  background-color: ${THEME.BACKGROUND};

  height: 100vh;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
`;
const SelectorWrapper = styled.div `
  max-width: 400px;
  margin: 100px auto 0 auto;
`;
//# sourceMappingURL=AccountSelectorPage.js.map